<template>
    <form @submit.prevent="saveRFTAccount" ref="form">
        <div v-if="disableReason" class="disable-overlay"><h3>{{ disableReason }}</h3></div>
        <input name="userId" type="hidden" :value="userId">
        <input v-if="account?.accountId" name="accountId" type="hidden" :value="account.accountId">
        <div class="form-group">
            <label for="username">Username</label>
            <input
                v-if="account?.accountId"
                id="username"
                name="username"
                class="form-control"
                :value="account.username"
                required
                readonly
            >
            <input v-else id="username" name="username" class="form-control" required>
        </div>
        <div class="form-group">
            <label for="publicKey">Public Key</label>
            <input
                id="publicKey"
                name="publicKey"
                class="form-control"
                placeholder="AAAAB3NzaC1yc..."
                required
                :value="account?.publicKey || ''"
            >
        </div>
        <div v-if="saveError" class="alert alert-danger" role="alert">
            {{ saveError }}
        </div>
        <app-button submit="submit" type="primary">Save</app-button>
        <loading-overlay :loading="isLoading"></loading-overlay>
    </form>
</template>

<script>
import LoadingOverlay from "../../components/LoadingOverlay.vue";
export default {
    components: {
        LoadingOverlay
    },
    props: {
        userId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
            account: null,
            saveError: "",
            isDisabled: false,
            disableReason: "",
        };
    },
    mounted() {
        this.isLoading = true;

        axios
            .get(route('rft.accounts.show', { user: this.userId }))
            .then(({ data }) => {
                this.account = data;
            })
            .catch((error) => {
                if (error?.response?.data?.error?.code === "sftp_client_not_found") {
                    this.disableReason = error.response.data.error.message;
                }

                console.error(error);
            })
            .finally(() => this.isLoading = false);
    },
    methods: {
        saveRFTAccount() {
            this.isLoading = true;
            this.saveError = "";

            axios
                .post(route('rft.accounts.save'), new FormData(this.$refs.form))
                .then(({ data }) => {
                    this.account = data;
                    this.$notifications.success("Saved.");
                })
                .catch((error) => {
                    console.error(error)
                    this.saveError = error.response.data.message;
                })
                .finally(() => this.isLoading = false);
        },
    },
};
</script>

<style lang="scss" scoped>
form {
    position: relative;

    .disable-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, 0.9);
    }
}
</style>
